/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

import { Profile } from '../../models/profile.model';
import { ArticlesService } from '../../services/articles.service';
import { StorageProvider } from '../../services/storage.provider';
import { InfoPopupComponent } from '../../shared/components/infopopup/infopopup';
import { MetaProvider } from '../../services/meta.provider';
import { GaEventTrackerProvider } from '../../services/gaeventtracker.provider';
import { Router } from '@angular/router';

@Component({
  selector: 'app-addprofile',
  templateUrl: 'addprofile.html',
  styleUrls: ['addprofile.scss']
})
export class AddProfilePage {
  public model = new Profile('', '', '', '', '', '');
  private access_token: string;
  public error: string;
  public error_coupon: string;
  public validation: any;
  public userstatus: any;

  constructor(
    private router: Router,
    private service: ArticlesService,
    public popoverCtrl: PopoverController,
    private storage: StorageProvider,
    private meta: MetaProvider,
    private ga: GaEventTrackerProvider
  ) {}

  ionViewWillEnter() {
    this.access_token = this.storage.getStorage('access_token');
  }

  ionViewDidEnter() {
    this.meta.clearHead();
  }

  createProfile(type: string, profile: Profile) {
    this.model.type = type;
    if (this.model.coupon) {
      this.service.checkPormoCode(this.model.coupon).subscribe(
        () => {

          this.service.createProfilePost(profile, this.access_token).subscribe(
            () => {
              this.ga.trackCouponEvent( 'Coupon sur compte existant', 'Validation du coupon', this.model.coupon.toString(), 0 );
              this.router.navigate(['profiles']);
            },
            (error) => this.error = ' Vos identifiants ne sont pas reconnus'
          );
        },
        (error) => {
          this.error_coupon = error.message;
        }
      );
    } else {
      this.service.createProfilePost(profile, this.access_token).subscribe(
        () => {
          this.router.navigate(['profiles']);
        },
        (error) => {
          this.error = 'Le profil n\'a pas pu être créé';
        }
      );
    }
  }

  onSubmit(formValues: any, event: Event) {
    event.preventDefault();
    if ( formValues.firstName && formValues.lastName && (formValues.subscriber_number || formValues.coupon) ) {
      if (formValues.coupon === undefined) {
        formValues.coupon = false;
      }
      const profile = {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        subscriber_number: formValues.subscriber_number,
        type: 'Children',
        coupon: formValues.coupon,
      };
      this.createProfile('Children', profile);
    }
  }

  async presentPopover(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step2-numeroabo' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent );
  }

  async presentPopover2(myEvent) {
    const popover = this.popoverCtrl.create({
      component: InfoPopupComponent,
      componentProps: { page: 'step3-promocode' },
      cssClass: 'password-tooltip'
    });
    (await popover).present(myEvent);
  }

  changeHandler(): void {
    if (!this.model.coupon) {
      this.error_coupon = '';
    }
  }

  isPage() {
    return 'create-profile';
  }
}
